(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-floating-header-toggle]');
    const closeTrigger = event.target.closest('[data-floating-header-close]');

    if (openTrigger) {
      const menu = document.getElementById(openTrigger.getAttribute('aria-controls'));
      if (!menu) return;
      const isOpen = openTrigger.getAttribute('aria-expanded') === 'true';
      openTrigger.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      document.body.classList.toggle('floating-header-menu-open', !isOpen);
    }

    if (closeTrigger) {
      const menu = closeTrigger.closest('.floating-header__mobile-menu');
      const toggle = document.querySelector('[data-floating-header-toggle][aria-expanded="true"]');
      if (menu) menu.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('floating-header-menu-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenu = document.querySelector('.floating-header__mobile-menu:not([hidden])');
    const toggle = document.querySelector('[data-floating-header-toggle][aria-expanded="true"]');
    if (openMenu) openMenu.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('floating-header-menu-open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /**
     * Hero carousel autoplay pause behavior, scoped to .hero-carousel only.
     * Does not modify the shared slideshow-component class in assets/slideshow.js —
     * it only calls the public suspend()/resume()/pause() methods that class
     * already exposes.
     */

    function getSlideshow(target) {
      var carousel = target.closest('.hero-carousel');
      if (!carousel) return null;
      return carousel.querySelector('.hero-carousel__slides');
    }

    // Mobile has no hover state, so mirror the component's own native
    // hover-to-pause behavior using touch start/end instead.
    document.addEventListener(
      'touchstart',
      function (event) {
        var slideshow = getSlideshow(event.target);
        if (slideshow && typeof slideshow.suspend === 'function') {
          slideshow.suspend();
        }
      },
      { passive: true }
    );

    document.addEventListener('touchend', function (event) {
      var slideshow = getSlideshow(event.target);
      if (slideshow && typeof slideshow.resume === 'function') {
        slideshow.resume();
      }
    });

    // A manual dot/arrow click is an explicit choice — autoplay should stop
    // for good rather than resuming and pulling the slide away again.
    document.addEventListener('click', function (event) {
      var control = event.target.closest('.hero-carousel .slideshow-control');
      if (!control) return;

      var slideshow = getSlideshow(event.target);
      if (slideshow && typeof slideshow.pause === 'function') {
        slideshow.pause();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
